import * as Redux from 'redux';

import {initialStateForSignin} from "./initialStateForSignIn.js";
import {actionTypesForSignin, signinStatuses} from "../constants/signinOverlayConstants.js";

const clearMessagesAndSigninStatus = (state) => {
    const result = $.extend({}, state);

    result.signinStatus = signinStatuses.NONE;
    result.errors=[];
    result.messages=[];
    result.loading=false;
    return result;
};

const init = (state = initialStateForSignin, action) => {
    const result = clearMessagesAndSigninStatus(state);
    result.showSigninOverlay = (typeof pageName != "undefined") ? (pageName == "signin") : false;
    result.isStandAloneSignin = (typeof pageName != "undefined") ? (pageName == "signin") : false;
    if (result.isStandAloneSignin && $("#user-credentials").length > 0) {
        let userCredentials = $("#user-credentials").data("user-credentials");
        result.signinStatus = userCredentials.signinStatus;
        result.username = userCredentials.username;
        result.first = userCredentials.first;
        result.primaryEmailHint = userCredentials.primaryEmailHint;
    } else {
        result.username = (userObj && userObj.email) ? userObj.email : "";
        if (! result.username) {
            var email = getURLParam(location.href, "email");
            if (email && isEmailAddress(email)) {
                result.username = email;
            }
        }
        result.first = (userObj) ? userObj.userName : "";  // UserCookieService sets the first name into the userName field
    }
    return result;
};

const returnToEmailView = (state, action) => {
    if (action.type === actionTypesForSignin.RETURN_TO_EMAIL_VIEW) {
        const result = clearMessagesAndSigninStatus(state);
        result.showSigninOverlay = true;
        return result;
    } else {
        return state;
    }
};

const setToggleOverlay = (state, action) => {
    if (action.type === actionTypesForSignin.TOGGLE_OVERLAY) {
        // reset form and messages if we're about to hide it
        const result = (state.showSigninOverlay) ? clearMessagesAndSigninStatus(state) : $.extend({}, state);
        result.showSigninOverlay = !state.showSigninOverlay;
        if (action.username) {
            result.username = action.username;
        }
        if (action.first) {
            result.first = action.first;
        }
        if (action.signinStatus) {
            result.signinStatus = action.signinStatus;
        }
        return result;
    } else {
        return state;
    }
};

const setUserCredentials = (state, action) => {
    if (action.type === actionTypesForSignin.SET_USERCREDENTIALS) {

        const result = $.extend({}, state);
        result.username = action.username;
        result.first = action.first;
        result.signinStatus = action.signinStatus;
        result.primaryEmailHint = action.primaryEmailHint
        result.messages = action.messages;
        result.errors = action.errors;
        result.loading = false;

        return result;

    } else {
        return state;
    }
};

const first = (state = initialStateForSignin.first, action) => {
    if (action.first) {
        return action.first;
    } else {
        return state;
    }
};

const username = (state = initialStateForSignin.username, action) => {
    if (action.type === actionTypesForSignin.SET_USERCREDENTIALS) {
        return action.username;
    } else {
        return state;
    }
}

const signinStatus = (state = initialStateForSignin.signinStatus, action) => {
    if (action.type === actionTypesForSignin.SET_USERCREDENTIALS) {
        return action.signinStatus;
    } else {
        return state;
    }
};

const messages = (state = initialStateForSignin.messages, action) => {
    if (action.type === actionTypesForSignin.SET_USERCREDENTIALS) {
        return action.messages;
    } else {
        return state;
    }
};

const errors = (state = initialStateForSignin.errors, action) => {
    if (action.type === actionTypesForSignin.SET_USERCREDENTIALS) {
        return action.errors;
    } else {
        return state;
    }
};

const primaryEmailHint = (state = initialStateForSignin.primaryEmailHint, action) => {
    if (action.type === actionTypesForSignin.SET_USERCREDENTIALS) {
        return action.primaryEmailHint;
    } else {
        return state;
    }
};

const showSigninOverlay = (state = initialStateForSignin.showSigninOverlay, action) => {
    if (action.type === actionTypesForSignin.TOGGLE_OVERLAY) {
        return ! state;
    } else {
        return state;
    }
};

const setToggleLoading = (state = initialStateForSignin.loading, action) => {
    if (action.type === actionTypesForSignin.TOGGLE_LOADING) {
        return !state;
    } else {
        return state;
    }
};

const isStandAloneSignin = (state = null) => state;

const normalReducers = Redux.combineReducers({
    username,
    first,
    signinStatus,
    showSigninOverlay,
    isStandAloneSignin,
    loading: setToggleLoading,
    errors,
    messages,
    primaryEmailHint
});

const combinedReducer = (state = initialStateForSignin, action) => {
    if (action.type === actionTypesForSignin.INIT) {
        return init(state, action)
    } else if (action.type === actionTypesForSignin.SET_USERCREDENTIALS) {
        return setUserCredentials(state, action)
    } else if (action.type === actionTypesForSignin.TOGGLE_OVERLAY) {
        return setToggleOverlay(state, action)
    } else if (action.type === actionTypesForSignin.RETURN_TO_EMAIL_VIEW) {
        return returnToEmailView(state, action)
    } else {
        return normalReducers(state, action)
    }
};

export const signinReducer = combinedReducer;


